import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  palette,
  spacing
}) => ({
  circularProgress: {
    marginRight: spacing(0.75),
    position: 'relative',
    top: spacing(0.5)
  },
  root: {
    borderBottom: `1px solid ${palette.grey[200]}`,
  }
}));
